import { render, staticRenderFns } from "./lxdownload.vue?vue&type=template&id=10f6ca18&scoped=true&"
import script from "./lxdownload.vue?vue&type=script&lang=js&"
export * from "./lxdownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f6ca18",
  null
  
)

export default component.exports